<template>
　<div>
    <h2>{{ this.sectionName }}</h2>
    <div class="slider">
      <slick ref="slick" :options="slickOptions" v-show="total_count">
        <div v-for="item in items" :key="item.id" class="post_clm">
          <a :href="'/detail/' + item.id">
            <div class="img_box" v-if="item.image_thumbnail !== null">
              <img :src="'/storage/customers/' + item.image_thumbnail" alt="" />
            </div>
            <div class="img_box" v-else>
              <img src="/assets/img/common/no_image.png" alt="no image" />
            </div>
            <div class="txt_box">
              <h3 class="height_align">{{ item.juristic_name }}</h3>
              <p class="distance" v-if="item.distance !== null && item.distance !== undefined">{{ item.distance }}<span v-if="item.unit !== null && item.unit !== undefined">{{ item.unit }}</span></p>
              <p class="distance" v-else>&nbsp;</p>
            </div>
          </a>
        </div>
      </slick>

      <div v-show="hasMessage">
        {{ this.message }}
      </div>

      <div class="spinner_area">
        <pulse-loader :loading="isLoading" :color="'#ff6969'" :size="'12px'"></pulse-loader>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from "vue-slick";
export default {
  // 初期値設定
  data() {
    return {
      total_count: 0,
      items: [],
      requested: false,
      sectionName: '',
      hasMessage: false,
      message: '',
      isLoading: false,
      // Slickオプション
      slickOptions: {
        cssEase: "ease-in-out",
        slidesToScroll: 9,
        slidesToShow: 9,
        speed: 1000,
        autoplaySpeed: 4000,
        infinite: false,
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToScroll: 3,
              slidesToShow: 3
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToScroll: 5,
              slidesToShow: 5
            }
          }
        ]
      }
    };
  },
  components: { Slick },
  props: {
    itemName: {
      type:String,
      default:"",
    },
    itemType: {
      type:String,
      default:"",
    },
    type: String,
    hashtag: String,
    hasGps: Boolean,
    limit: {
      type:Number,
      default: 30,
    }
  },
  methods: {
    getPosts() {
      this.isLoading = true;
      if(this.itemName) {
        this.sectionName = this.itemName + this.itemType;
      }
      const params = {
        type: this.type,
        tag: this.hashtag,
        limit: this.limit,
      };
      if (this.hasGps && this.$coordsAvailability && this.$coordsGeoDistance) {
        params.latitude = this.$coords.latitude;
        params.longitude = this.$coords.longitude;
        params.distance = this.$coords.geoDistance;
        this.sectionName = '近くの' + this.sectionName;
      }
      var self = this;
      axios
        .post("/api/customers", params)
        // 成功時処理
        .then(res => {
          self.total_count = res.data.total_count;
          self.items = res.data.items;
          self.requested = true;
          this.isLoading = false;
          this.showMessages();
        })
        // エラーレスポンス時処理
        .catch(error => {
          self.requested = true;
          this.isLoading = false;
          console.log(error);
          this.showMessages();
        });
    },
    showMessages() {
      // データが見つからない場合のメッセージ表示
      if (this.requested && this.total_count === 0) {
        this.message = this.itemName + 'が見つかりませんでした。';
        if(this.hashtag == "求人") {
          this.message = "求人中の" + this.message;
        }
        this.hasMessage = true;
      } else {
        this.hasMessage = false;
      }
    }
  },
  watch : {
    // 位置情報状態を監視
    $coordsAvailability () {
      // 位置情報状態が変化したらデータ取得開始
      this.getPosts();
    },
    $coordsGeoDistance () {
      // 位置情報状態が変化したらデータ取得開始
      this.getPosts();
    }
  },
  next() {
    this.$refs.slick.next();
  },
  prev() {
    this.$refs.slick.prev();
  },
  reInit() {
    this.$nextTick(() => {
      this.$refs.slick.reSlick();
    });
  },
  created() {
    // GPS取得が不要なら位置情報を無効とする
    if (this.hasGps === false) {
      this.$coordsAvailability = false;
    }
  },
  beforeUpdate() {
    if (this.$refs.slick) {
      this.$refs.slick.destroy();
    }
  },
  updated() {
    this.$nextTick(function() {
      if (this.$refs.slick) {
        this.$refs.slick.create(this.slickOptions);
      }

      // 以下高さを揃える処理
      const nodes = document.getElementsByClassName('height_align')
      let maxHeight = '0px'
      // 各要素の高さを取得
      for (let i = 0; i < nodes.length; i++) {
        const height = window.getComputedStyle(nodes[i]).height
        if (maxHeight < height) {
          maxHeight = height
        }
      }
      // 一番高いやつに高さを合わせる
      for (let i = 0; i < nodes.length; i++) {
        nodes[i].style.height = maxHeight
      }
    });
  }
};
</script>